<template>
    <div class='attribute-wrapper'>
        <div class='left-info sub-text-99'>
            <div v-if='propsData.type == 2'>{{propsData.source}}</div>
            <div v-if='propsData.type == 1'>
                <img :src="sourceImgUrl">
            </div>
            <div>{{ ctime }}</div>
            <div :key="this.propsData.seq">{{ num }}人已读</div>
        </div>
    </div>
</template>

<script>
import * as actions from '@/common/js/api'

export default {
    name: '',
    data() {
        return {
            num: '',
            value: '',
            theme: '',
            isShowMenu: false
        }
    },
    props: {
        propsData: {
            type: Object,
            default() {
                return {
                    type: '', //  1 , 2  1代表取图片  2 代表取文字 
                    sourceImgUrl: '',
                    source: '',
                    ctime: '',//
                    nature: '',// 判断利好利空无 中性  映射关系待定
                    key: '', // 用于向后端请求阅读量 
                    app: '',
                    token: '',
                }
            }
        }
    },
    computed: {
        ctime() {
            return this.$utils.thscSnsBaselibUtils.getPublishTime(this.propsData.ctime * 1000, {
                '60s': '刚刚',
                '60m': '{nm}分钟前',
                'yesterday': '昨天{hh}:{mm}',
                '24h': '{nh}小时前',
                '1y': '{YYYY}-{MM}-{DD} {hh}:{mm}',
                'xy': '{YYYY}-{MM}-{DD}'
            })
        },
        sourceImgUrl() {
            if (this.theme == 'night') {
                let imgSrc = this.$utils.word2Img({
                    fontHeight: 11,
                    fontColor: '#5D6265',
                    lineHeight: 9,
                    word: this.propsData['source'],
                    fontStyle: `200 14px 微软雅黑`
                })
                return imgSrc
            } else {
                let imgSrc = this.$utils.word2Img({
                    fontHeight: 11,
                    fontColor: '#999999',
                    lineHeight: 9,
                    word: this.propsData['source'],
                    fontStyle: `200 14px 微软雅黑`
                })
                return imgSrc
            }
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        this.$client.getBrowserDlgSkin().then(res => {
            this.theme = res == 0 ? 'daily' : 'night'
        })
        // this.$nextTick(function () {
        this.numberView(this.propsData);
        // })
        this.registerEmitterListener();
    },
    watch: {
        propsData: {
            handler(newVal) {
                if (newVal) {
                    this.numberView(newVal)
                }
            },
            immediate: true
        }
    },
    components: {
        // MenuBox
    },
    methods: {
        numberView(e) {
            let art_id = e.key
            // this.$commonApi.getViewNumberInPromise({key:e.key}).then( res => {
            // 	if( res.errorcode == 0){
            // 		this.num = res.result[art_id];
            // 	}  	
            // })

            // 0.0.9
            commonApi.getViews({ key: e.key, app: e.app, inc: 1, token: e.token }).then(res => {
                console.log('新commonApi获取浏览量', res);
                if (res.errorcode == 0) {
                    this.num = res.result[art_id];
                }
            }).catch (e => {
                console.log("numberView", e)
            }) 
        },
        registerEmitterListener() {
            this.$on('MESSAGE_TO_CHILD', (params) => {
                if (params.method == 'changeSkin') {
                    this.theme = params.data
                }
            })
        },
        ctrlMenuShow() {
            // this.$sendStat(this.$pageStat(this.propsData.seq, 'menu')('menuclick'));
            console.log('点击菜单')
            this.$sendPoint('menuclick')

            this.isShowMenu = !this.isShowMenu;
        },
        closeShowMenu() {
            this.isShowMenu = false;
        }
    }
}
</script>

<style lang="less" scoped>
@import '../../common/style/common-color.less';

.attribute-wrapper {
    // display:-webkit-flex;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    line-height: 19px;
    > .left-info {
        display: flex;
        > div {
            cursor: pointer;
            &:first-child {
                margin-right: 16px;
                display: flex;
                align-items: center;
            }
            &:last-child {
                margin-left: 10px;
            }
        }
    }
    > .right-info {
        font-size: 12px;
        line-height: 8px;
        // padding: 3px 4px 1px 4px;
        text-align: center;
        align-items: center;
        position: relative;
        cursor: pointer;
        border-radius: 2px;
        > .click-box {
            width: 24px;
            height: 21px;
            display: flex;
            align-items: center;
            justify-content: center;
            > img {
                width: 14px;
                height: 11px;
            }
        }
        > .menu-block {
            > .menu-list {
                position: absolute;
                right: 0;
                top: 30px;
                z-index: 100;
            }
        }
    }
}
</style>
